import { Heading, Text, textVariants } from '@etg/wings';
import { Notification, variants } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import { css, etiColors } from '@eti/styles';
import PaymentTrustSeals from './PaymentTrustSeals';

const disabledStyles = css`
  color: ${etiColors.grayScale[9]};
`;

interface PaymentHeaderProps {
  isPayInternalPayment?: boolean;
  paymentMethodsSize: number;
}

const PaymentHeader = ({
  isPayInternalPayment = false,
  paymentMethodsSize,
}: PaymentHeaderProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const isPaymentSealsEnabled = p('Payment.PaymentSeals.V2.Enabled');

  return (
    <>
      {paymentMethodsSize > 1 && (
        <Heading
          className={isPayInternalPayment ? disabledStyles : undefined}
          id="choosePaymentMethodHeader"
          level={2}
        >
          {t('PaymentPage.Payment.Method.Header.Text')}
        </Heading>
      )}
      {isPayInternalPayment && (
        <Notification
          dataTestId="payment-notification-zeroAmountCart"
          variant={variants.INFORMATION}
        >
          <Text variant={textVariants._14_BOLD}>{t('Payment.ZeroAmountCart.Description')}</Text>
        </Notification>
      )}
      {isPaymentSealsEnabled && <PaymentTrustSeals />}
    </>
  );
};

export default PaymentHeader;
